var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43334 5.83333V5.73333H9.33334H2.66667H2.56667V5.83333V14.7222V14.8222H2.66667H9.33334H9.43334V14.7222V5.83333ZM3.08334 1.48889H3.12666L3.15629 1.45728L3.96 0.6H8.04002L8.84372 1.45728L8.87335 1.48889H8.91667H11.7333V3.06667H0.266672V1.48889H3.08334ZM1.10001 14.7222V4.15556H10.9V14.7222C10.9 15.6509 10.1888 16.4 9.33334 16.4H2.66667C1.81121 16.4 1.10001 15.6509 1.10001 14.7222Z",
    fill: "#D33D3D",
    stroke: "#FBE2E2",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDel);
export default __webpack_public_path__ + "static/media/chatDel.3d2efd21d8ba5c1db48c551bc07946b9.svg";
export { ForwardRef as ReactComponent };